import { FC } from 'react';
import { generalBlue, googleMapConfig } from 'src/app-config';
import { GoogleMap, Polygon, useJsApiLoader } from '@react-google-maps/api';
import { hthMapStyle } from 'src/components/_commons/house-to-house';
import { Loading } from 'src/components/_commons';
import { typeHTHTerritory } from '@monorepo/models';
import { useGetIsMobile, useOnEscapeKey } from 'src/custom-hooks';

type propsType = {
    close: () => void;
    hthTerritory: typeHTHTerritory;
};

export const HTHRestructuringMap: FC<propsType> = ({ close, hthTerritory }) => {
    const mapLoader = useJsApiLoader(googleMapConfig);
    const isMobile = useGetIsMobile();

    useOnEscapeKey(close);

    if (!mapLoader.isLoaded) {
        return <Loading />;
    }

    return (
        <div className={'offcanvas offcanvas-top show'} style={{ height: '90vh' }} tabIndex={-1}>
            <div className={'offcanvas-header bg-general-blue'}>
                <h3 className={'text-white'}>
                    Territorio {hthTerritory.territoryNumber} en el Mapa
                </h3>
                <button className={'btn-close text-reset'} onClick={close}></button>
            </div>
            <div className={'offcanvas-body bg-dark'}>
                <GoogleMap
                    center={hthTerritory.centerCoords}
                    id={googleMapConfig.id}
                    mapContainerClassName={isMobile ? 'position-absolute' : 'd-block m-auto'}
                    mapContainerStyle={{
                        height: isMobile ? '600px' : '70vh',
                        width: isMobile ? '100%' : '90%'
                    }}
                    // onLoad={mapInstance => setMap(mapInstance)}
                    options={{
                        center: hthTerritory.centerCoords,
                        disableDefaultUI: false,
                        fullscreenControl: true,
                        fullscreenControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER },
                        isFractionalZoomEnabled: true,
                        mapTypeControl: false,
                        minZoom: 8,
                        panControl: true,
                        streetViewControl: true,
                        styles: hthMapStyle,
                        zoomControl: true,
                        zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM }
                    }}
                    zoom={hthTerritory.zoom - 1}
                >
                    {!!hthTerritory.faces?.length && hthTerritory.faces.map(polygon =>
                        <Polygon
                            options={{
                                clickable: true,
                                fillColor: generalBlue,
                                fillOpacity: 0.92,
                                strokeColor: '',
                                strokeOpacity: 0.9,
                                strokePosition: google.maps.StrokePosition.CENTER,
                                strokeWeight: 10
                            }}
                            path={[
                                polygon.coordsPoint1,
                                polygon.coordsPoint2,
                                polygon.coordsPoint3
                            ]}
                        />
                    )}
                </GoogleMap>
            </div>
            <div className={'bg-general-blue'} style={{ height: '10px' }}></div>
        </div>
    );
}
